import about_three_info from "../../../assets/images/about/about-three-info.png";
import about_three_image from "../../../assets/images/about/about-three-image.png";
import about_two_user1 from "../../../assets/images/about/about-two-user1.png";
import about_two_user2 from "../../../assets/images/about/about-two-user2.png";
import about_two_user3 from "../../../assets/images/about/about-two-user3.png";
import about_two_user4 from "../../../assets/images/about/about-two-user4.png";
import about_two_line from "../../../assets/images/about/about-two-line.png";

const AboutSection = () => {
  return (
    <>
      {/* About area start here */}
      <section className="about-section-three pt-120 pb-10">
        <div className="container">
          <div className="row g-5 g-xxl-0">
            <div className="col-xl-6 image-column">
              <div className="inner-column">
                <div className="shape">
                  <img
                    className="animation__rotate"
                    style={{width:"200px", height:"196px"}}
                    src={about_three_info}
                    alt="Image"
                  />
                </div>
                <figure className="image">
                  <img src={about_three_image} alt="Image" />
                </figure>
                <p
                  className="text mt-30 wow fadeInUp"
                  data-wow-delay="200ms"
                  data-wow-duration="1500ms"
                >
                  We are an inspection and technical services company set up,
                  delivering independent, reliable assessment and assurance
                  across the Kingdom of Saudi Arabia. Through our ability, we
                  help ensure quality, operational integrity, and safety,
                  supporting industries and communities that depend on secure
                  and sustainable infrastructure.
                </p>
                <p
                  className="text mt-30 wow fadeInUp"
                  data-wow-delay="200ms"
                  data-wow-duration="1500ms"
                >
                  We strive to be at the forefront of the inspection services
                  industry. Our professionals apply their ability and dedication
                  to addressing operational challenges and critical safety
                  risks, helping organizations, protect assets, people, and the
                  environments in which they work.
                </p>
                <p
                  className="text mt-30 wow fadeInUp"
                  data-wow-delay="200ms"
                  data-wow-duration="1500ms"
                >
                  We aim to be a trusted partner to our clients by delivering
                  dependable, high-quality inspection services. For our
                  stakeholders, we create lasting value through consistent
                  performance and responsible growth. For the communities we
                  serve, we are committed to safe and reliable operations.
                </p>
              </div>
            </div>
            <div className="col-xl-6 content-column">
              <div className="inner-column">
                <div className="sec-title">
                  <h6
                    className="sub-title wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    ABOUT US
                  </h6>
                  <h2 className="title wow splt-txt" data-splitting>
                    <span className="font-weight-300">We deliver reliable</span>{" "}
                    inspection services
                    <span className="font-weight-300">to ensure</span> safety
                    and quality
                  </h2>
                </div>
                <div className="about-block-three mt-50">
                  <div className="row g-0">
                    <div
                      className="col-sm-6 wow fadeInLeft"
                      data-wow-delay="200ms"
                      data-wow-duration="1500ms"
                    >
                      <div className="content-box">
                        <div className="count-box">
                          <span
                            className="count-text"
                            data-stop={10}
                            data-speed={2000}
                          />
                          +
                        </div>
                        <p className="text">Years of Experience</p>
                      </div>
                    </div>
                    <div
                      className="col-sm-6 wow fadeInRight"
                      data-wow-delay="200ms"
                      data-wow-duration="1500ms"
                    >
                      <div className="content-box margin-minus">
                        <div className="count-box">
                          <span
                            className="count-text"
                            data-stop={100}
                            data-speed={2000}
                          />
                          +
                        </div>
                        <p className="text">Projects Completed</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* About area end here */}
    </>
  );
}

export default AboutSection